import React from "react";
const TextArea = ({ disabled, maxWidth, placeholder, value, onChange, height }) => {
    const minHeight = "60px";
    return <textarea className="TextField-small-filled" disabled={disabled}
        style={{ flexGrow: "1", 
            flexShrink: "0", 
            minHeight: minHeight, 
            fontSize: "14px", 
            padding: "20px 10px",
            opacity: disabled ? "0.5" : "1",
            whiteSpace: "pre-line",
            backgroundColor: "var(--input-background)",
            textWrap: "wrap", 
            overflowY: "scroll",
            height: height ? height : minHeight,
            maxWidth: maxWidth ? maxWidth + "px" : null }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}/>;
};
export default TextArea;
